import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-503c7c8b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dn-actions-widget" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("简体中文")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("English")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("发布")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_radio_group, {
      modelValue: _ctx.language,
      onChange: _ctx.handleChangeLanguage
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_radio_button, { label: "zh-cn" }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_radio_button, { label: "en-us" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "onChange"]),
    _createVNode(_component_el_button, {
      style: { marginLeft: '10px' },
      onClick: _ctx.handleSaveSchema
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_el_button, { onClick: _ctx.handleSaveSchema }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}